import type { FC } from 'react'
import { useCallback } from 'react'

import { useUI } from '@components/ui'
import Button from '@components/ui/Button'

interface LoginModalButtonProps {
  label: string
  num: number
  title: string | any
  subtitle: string | any
}

const LoginModalButton: FC<LoginModalButtonProps> = ({
  label,
  num,
  title,
  subtitle,
}) => {
  const { openModal, setModalView } = useUI()

  const handleShowModal = useCallback(() => {
    setModalView('LOGIN_MODAL', 'w-full max-w-sm', undefined, {
      title,
      subtitle,
    })
    openModal()
  }, [openModal, setModalView, title, subtitle])

  return (
    <Button className="whitespace-nowrap" onClick={handleShowModal}>
      {label}
      <span className="ml-2 text-slate-400">{num}</span>
    </Button>
  )
}

export default LoginModalButton
